import React from 'react';
import cn from 'classnames';

import CN from './PasswordInputField.module.scss';

class PasswordInputField extends React.Component {
  static defaultProps = {
    onChangeHandler: () => {},
    onBlurHandler: () => {},
    validateChange: () => true,
    validateBlur: () => '',
  };

  constructor(props) {
    super(props);

    this.state = {
      type: props.data.type,
      inputValue: this.props.data.inputValue,
      errorMessage: '',
      touched: false,
    };
  }

  onChange = (event) => {
    const { target } = event;
    const { value } = target;
    const { id } = target;
    if (this.props.validateChange && !this.props.validateChange(value)) {
      return;
    }
    this.setState({ inputValue: value }, () => {
      if (this.props.onChangeHandler) {
        this.props.onChangeHandler(value, id);
      }
    });
    if (this.props.validateBlur && this.state.touched) {
      const errorMessage = this.props.validateBlur(value);
      this.setState({ errorMessage });
    }
  };

  onBlur = (event) => {
    const { validateBlur, onBlurHandler } = this.props;
    const { id, value } = event.target;

    if (validateBlur) {
      this.setState({ errorMessage: validateBlur(value) });
    }

    if (onBlurHandler) {
      onBlurHandler(value, id);
    }

    if (!this.state.touched) {
      this.setState({ touched: true });
    }
  };

  showHidePassword = () => {
    this.setState({
      type: this.state.type === 'text' ? 'password' : 'text',
    });
  };

  render() {
    return (
      <div className={CN.inputContainer}>
        <div className={CN.passwordContainer}>
          <span className={CN.inputLabel}> {this.props.data.label}</span>
          <input
            className={cn({
              [CN.input]: true,
              [CN.hasError]: this.state.errorMessage,
            })}
            id={this.props.data.id}
            type={this.state.type}
            placeholder={this.props.data.placeholder}
            value={this.state.inputValue}
            onChange={this.onChange}
            onBlur={this.onBlur}
            autoComplete={this.props.allowAutocomplete ? '' : 'new-password'}
          />

          <div className={CN.eyeContainer} role="button" tabIndex="0" onClick={this.showHidePassword}>
            {this.state.type === 'text' ? <div className={CN.eyeOpen} /> : <div className={CN.eyeClose} />}
          </div>
        </div>

        {this.state.errorMessage && <span className={CN.error}>{this.state.errorMessage}</span>}
      </div>
    );
  }
}

export default PasswordInputField;
